export default {
  subtotal: 'Subtotale',
  tip: 'Mancia',
  discount: 'Sconto',
  method_fee: 'Costo di consegna',
  service_fee: {
    title: 'Costo del servizio',
    description:
      "Questo piccolo costo di servizio ci aiuta a coprire le spese legate a ogni ordine — come l'invio di aggiornamenti SMS, la gestione della piattaforma di ordinazione online e le commissioni sulle transazioni. Non preoccuparti — questa tariffa è comunque molto inferiore a quella delle app di consegna. Grazie per la comprensione e per supportarci direttamente. Ti siamo grati!",
  },
  payment_method_upcharge_fee: {
    title: 'Commissione PayPal',
    description:
      "Ogni volta che un cliente paga con PayPal, PayPal addebita commissioni del 6-7%. Su 100€ perdiamo quindi 6-7€. Purtroppo siamo costretti ad applicare un supplemento del 3,5% per l'utilizzo di PayPal. 🤯 Ti invitiamo a scegliere uno degli altri metodi di pagamento sicuri e cifrati al momento del pagamento. Siamo molto grati per la tua comprensione e il tuo supporto! 🙏",
  },
  tax: 'Tasse',
  total: 'Totale',
  earned_points: 'Hai guadagnato {{points}} punti',
};
